export class ModuleMetaData {
    moduleName: string;
    primaryKey: string;
    displayKey: string;
}